export class BitfinexCurrencyEnabledChange {
  abosAccountId: any;
  bitfinexAccountId: any;
  currency: string;
  isEnabled: boolean;
  isSwap: boolean;

  constructor(abosAccountId: any, bitfinexAccountId: number, currency: string, isEnabled: boolean, isSwap: boolean) {
    this.abosAccountId = abosAccountId;
    this.bitfinexAccountId = bitfinexAccountId;
    this.currency = currency;
    this.isEnabled = isEnabled;
    this.isSwap = isSwap;
  }
}
